import { errors } from 'rfc9457';

import { readEnvVariable } from '../helpers';

export interface IEmailResendEnv {
  apiKey: string;
}

export function getEmailResendEnv(): IEmailResendEnv {
  const apiKey = readEnvVariable('EMAIL_RESEND_API_KEY');

  if (!apiKey) {
    throw errors.server.envNotSet('EMAIL_RESEND_API_KEY');
  }

  return { apiKey };
}
